import Vue from 'vue'
import VueFacade from 'vue-input-facade'

Vue.use(VueFacade)
